import React from "react";
import { FormattedMessage } from "@irati/utils/lang";
import { H2, H3 } from "@irati/ui/src/Typography";
var SpecialRates = function (_a) {
    var id = _a.id, small = _a.small;
    var Heading = small ? H3 : H2;
    return (React.createElement(Heading, { id: id, "data-test": "special-rates" },
        React.createElement(FormattedMessage, { id: "perks.components.saving.special" }),
        React.createElement("br", null),
        React.createElement(FormattedMessage, { id: "perks.components.saving.rates" })));
};
export default SpecialRates;
